/*! ws-order-limits.js — 注文数量の制限 (2026-09-08 Winds Score / アプリ Order Limits の置き換え)
 *
 *  ルールの判定は snippets/ws-order-limit-rule.liquid が行い、ここは
 *    商品ページ: 選択中バリエーションの最小/最大を数量欄に反映し、外れていれば「カートに追加」を止める
 *    カート:     各行(バリエーション単位)と商品合計(商品単位)を見て、外れていればチェックアウトを止める
 *  だけを担当する。
 *
 *  ボタンの disabled は他の自作スクリプトと取り合いになる(印で仲裁):
 *    data-wszep-disabled / data-wspre-locked / data-wscopy-locked / data-wsopt-locked / data-wsol-locked(ここ)
 *  自分の印があるときだけ外し、他の印が残っていれば外さない。元から disabled のボタンには触らない。
 *  wsqty-confirm.js は印なしで disabled を書き換えるので、attribute 監視で掛け直す。
 */
(function () {
  'use strict';

  var OTHER_LOCKS = ['data-wspre-locked', 'data-wszep-disabled', 'data-wscopy-locked', 'data-wsopt-locked'];

  // アプリ Order Limits と同じ文言
  function msgMin(n) { return 'この商品は' + n + '個以上で購入できます。'; }
  function msgMax1() { return 'おひとり様1回限り購入可能です。'; }

  // ------------------------------------------------------------------ 共通
  function lockedByOthers(el) {
    for (var i = 0; i < OTHER_LOCKS.length; i++) if (el.hasAttribute(OTHER_LOCKS[i])) return true;
    return false;
  }

  // respectInit: 商品ページの「カートに追加」は売り切れ等で元から disabled のことがあるので触らない。
  //              カートの「ご購入手続きへ」は元から disabled のことはない(wsqty-confirm.js が印なしで止めているだけ)ので無視する
  function lock(el, want, respectInit) {
    if (respectInit) {
      // 元から disabled(売り切れ等)かの記録。他の自作スクリプトの印つきで disabled なら「元から」ではない
      if (el.getAttribute('data-wsol-init') === null) el.setAttribute('data-wsol-init', (el.disabled && !lockedByOthers(el)) ? '1' : '0');
      if (el.getAttribute('data-wsol-init') === '1') return;        // 元から買えないボタンには触らない
    }
    if (want) {
      el.setAttribute('data-wsol-locked', '');
      if (el.disabled !== true) el.disabled = true;                 // 同値なら触らない(監視の再帰防止)
      el.setAttribute('aria-disabled', 'true');
    } else if (el.hasAttribute('data-wsol-locked')) {
      el.removeAttribute('data-wsol-locked');
      if (lockedByOthers(el)) return;
      if (el.disabled !== false) el.disabled = false;
      el.setAttribute('aria-disabled', 'false');
    }
  }

  function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
  function show(el, on) { if (el.hidden !== !on) el.hidden = !on; }

  function boxFor(anchor, cls, attr, before) {
    var parent = anchor.parentNode;
    var box = parent.querySelector('[' + attr + ']');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute(attr, '');
      box.className = cls;
      box.hidden = true;
      parent.insertBefore(box, before ? anchor : anchor.nextSibling);
    }
    return box;
  }

  // ------------------------------------------------------------------ 商品ページ
  function ruleForForm(form) {
    var el = form.querySelector('[data-wsol-rules]');
    if (!el) return null;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return null; }
    var idInput = form.querySelector('[name="id"]');
    var vid = idInput ? String(idInput.value) : '';
    var vmin = (data.variants && data.variants[vid]) ? parseInt(data.variants[vid], 10) : 0;
    var pmin = parseInt(data.pmin, 10) || 0;
    var pmax = parseInt(data.pmax, 10) || 0;
    var min = Math.max(vmin, pmin);
    return { min: min, max: pmax };
  }

  function syncProductForm(form) {
    var btn = form.querySelector('[name="add"], .add-to-cart, button[type="submit"]');
    var qty = form.querySelector('input[name="quantity"]') ||
              document.querySelector('input[name="quantity"][form="' + form.getAttribute('id') + '"]');   // form.id は name="id" の select に食われる
    if (!btn) return;
    var rule = ruleForForm(form);
    var box = boxFor(btn, 'wsol__msg', 'data-wsol-msg', true);

    if (!rule || (rule.min <= 1 && !rule.max)) {
      // ルールなし。前に自分が数量を持ち上げていたら 1 に戻す(ダウンロード版に切り替えたとき等)
      if (qty && qty.getAttribute('data-wsol-auto') && parseInt(qty.value, 10) === parseInt(qty.getAttribute('data-wsol-auto'), 10)) {
        qty.value = '1';
      }
      if (qty) { qty.removeAttribute('data-wsol-auto'); if (qty.getAttribute('min') !== '1') qty.setAttribute('min', '1'); qty.removeAttribute('max'); }
      show(box, false);
      lock(btn, false, true);
      return;
    }

    var q = qty ? parseInt(qty.value, 10) || 0 : 1;
    var text = '';
    if (rule.max === 1) text = msgMax1();
    else if (rule.min > 1) text = msgMin(rule.min);

    if (qty) {
      if (rule.min > 1) {
        if (qty.getAttribute('min') !== String(rule.min)) qty.setAttribute('min', String(rule.min));
        if (q < rule.min) { qty.value = String(rule.min); qty.setAttribute('data-wsol-auto', String(rule.min)); q = rule.min; }
      } else if (qty.getAttribute('min') !== '1') qty.setAttribute('min', '1');
      if (rule.max) {
        if (qty.getAttribute('max') !== String(rule.max)) qty.setAttribute('max', String(rule.max));
        if (q > rule.max) { qty.value = String(rule.max); q = rule.max; }
      } else qty.removeAttribute('max');
    }
    setText(box, text);
    show(box, !!text);
    var bad = (rule.min > 1 && q < rule.min) || (rule.max && q > rule.max);
    lock(btn, !!bad, true);
  }

  // ------------------------------------------------------------------ カート
  function cartViolations(form) {
    var lines = form.querySelectorAll('.cart__item');
    var byProduct = {};       // 商品単位の合計
    var out = [];
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var tag = line.querySelector('[data-wsol]');
      if (!tag) continue;
      var qtyEl = line.querySelector('input[name="updates[]"]');
      var q = qtyEl ? parseInt(qtyEl.value, 10) || 0 : 0;
      var pid = tag.getAttribute('data-product-id');
      var title = tag.getAttribute('data-title') || '';
      var vmin = parseInt(tag.getAttribute('data-vmin'), 10) || 0;
      var pmin = parseInt(tag.getAttribute('data-pmin'), 10) || 0;
      var pmax = parseInt(tag.getAttribute('data-pmax'), 10) || 0;
      if (vmin > 1 && q > 0 && q < vmin) out.push('「' + title + '」は' + vmin + '個以上で購入できます（現在 ' + q + '個）');
      if (pmin > 1 || pmax > 0) {
        var b = byProduct[pid] || (byProduct[pid] = { q: 0, pmin: pmin, pmax: pmax, title: title });
        b.q += q;
      }
    }
    for (var k in byProduct) {
      var b2 = byProduct[k];
      if (b2.pmin > 1 && b2.q > 0 && b2.q < b2.pmin) out.push('「' + b2.title + '」は' + b2.pmin + '個以上で購入できます（現在 ' + b2.q + '個）');
      if (b2.pmax > 0 && b2.q > b2.pmax) out.push('「' + b2.title + '」はおひとり様' + b2.pmax + '個限りです（現在 ' + b2.q + '個）');
    }
    return out;
  }

  function syncCartForm(form) {
    var btn = form.querySelector('button[name="checkout"]');
    if (!btn) return;
    if (!form.querySelectorAll('input[name="updates[]"]').length) return;   // 商品行が無いフォームは判定しない
    var v = cartViolations(form);
    var box = boxFor(btn, 'wsol__cart-msg', 'data-wsol-cart-msg', false);
    var html = v.map(function (t) { return '<div>' + t + '</div>'; }).join('');
    if (box.innerHTML !== html) box.innerHTML = html;
    show(box, v.length > 0);
    lock(btn, v.length > 0, false);
  }

  // ------------------------------------------------------------------ まとめ
  function syncAll() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) if (forms[i].querySelector('[data-wsol-rules]')) syncProductForm(forms[i]);
    var carts = document.querySelectorAll('#CartPageForm, #CartDrawerForm');
    for (var j = 0; j < carts.length; j++) syncCartForm(carts[j]);
  }

  function init() {
    syncAll();
    ['change', 'input'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(syncAll, 0); }, true);
    });
    document.addEventListener('variant:change', function () { setTimeout(syncAll, 0); }, true);
    document.addEventListener('cart:build', function () { setTimeout(syncAll, 50); }, true);
    if (window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(syncAll, 120); })
        .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
